import {
  ActiveInactiveButton,
  CollapsiblePanel,
  CustomLabel,
  FlexContainer,
  ITableHeaders,
  TableContainer,
  TableWithHeaderButtons,
  UtilityMethods,
} from "@mindmemobile/mm-shared-global";
import React, { useState } from "react";
import { TableGrid } from "../../../shared/components";
import EditIcon from "../../../../../../images/products/edit-blue.svg";
import DeleteIcon from "../../../../../../images/products/trash-blue.svg";
import YesTick from "../../../../../../images/common/yes-tick-grey.svg";
import { PromotionGridModel } from "../../../shared/models/PromotionModels";
import { RolesAndPermissionStore } from "../../../shared/store";
import NewPromotionPopUp from "./NewPromotionPopUp";
import DeletePromotionPopUp from "./DeletePromotionPopUp";

type IProps = {
  data: PromotionGridModel[];
  rolesAndPermissionStore: RolesAndPermissionStore;
  onRefresh?: (refresh: boolean) => void;
};

export const PromotionsGrid: React.FC<IProps> = ({
  data,
  rolesAndPermissionStore,
  onRefresh,
}) => {
  const [actions, setActions] = useState({
    showEdit: false,
    showNew: false,
    promotionId: "",
    showDelete: false,
    isActive: false,
  });

  const showTableHeader = data.length > 0 ? true : false;

  function columns() {
    const columns: ITableHeaders<PromotionGridModel>[] = [
      {
        dataKey: "status",
        title: "Status",
        className: "table-col-15",
        cellClassName: "table-col-15",
        onCellRender: (data: PromotionGridModel) => {
          return (
            <ActiveInactiveButton
            //  minWidth="70px"
            >
              {data.status ? "Active" : "Inactive"}
            </ActiveInactiveButton>
          );
        },
      },
      {
        dataKey: "name",
        title: "Name",
        className: "table-col-20",
        cellClassName: "table-col-20",
        onCellRender: (data: PromotionGridModel) => {
          return <CustomLabel>{data.name}</CustomLabel>;
        },
      },
      {
        dataKey: "promoCode",
        title: "Promo Code",
        className: "table-col-15",
        cellClassName: "table-col-15",
        onCellRender: (data: PromotionGridModel) => {
          return (
            <CustomLabel className="overflow-ellipsis">
              {data.promoCode}
            </CustomLabel>
          );
        },
      },
      {
        dataKey: "restrictions",
        title: "Restrictions",
        className: "table-col-20 text-center",
        cellClassName: "table-col-20 text-center" ,
        onCellRender: (data: PromotionGridModel) => {
          return data.restrictions ? (
            <img
              src={YesTick}
              alt="tick-icon"
              onClick={() => {}}
              className="img-15 clickable"
            />
          ) : (
            ""
          );
        },
      },
      {
        dataKey: "lastUsed",
        title: "Last Used",
        className: "table-col-15",
        cellClassName: "table-col-15",
        onCellRender: (data: PromotionGridModel) => {
          return (
            <CustomLabel>
              {data.lastUsed
                ? UtilityMethods.formatDateInString(data.lastUsed)
                : "Not Used"}
            </CustomLabel>
          );
        },
      },
      {
        dataKey: "restrictions",
        title: "Actions",
        className: "table-col-10 text-center",
        cellClassName: "table-col-10 text-center",
        onCellClick: (e) => {
          e.stopPropagation();
        },
        onCellRender: (data: PromotionGridModel) => {
          return (
            <FlexContainer
              alignItems="center"
              justifyContent="center"
              spacing={10}
            >
              <img
                src={EditIcon}
                alt="edit-icon"
                onClick={(e) => {
                  e.stopPropagation();
                  if (!rolesAndPermissionStore.hasManagePermission("Edit"))
                    return;
                  setActions({
                    ...actions,
                    showEdit: true,
                    promotionId: data.id,
                    isActive: data.status === "Active",
                  });
                }}
                className="img-15 clickable"
              />
              <img
                src={DeleteIcon}
                alt="delete-icon"
                onClick={(e) => {
                  e.stopPropagation();
                  if (!rolesAndPermissionStore.hasManagePermission("Delete"))
                    return;
                  setActions({
                    ...actions,
                    showDelete: true,
                    promotionId: data.id,
                    isActive: data.status === "Active",
                  });
                }}
                className="img-15 clickable"
              />
            </FlexContainer>
          );
        },
      },
    ];
    return columns;
  }

  return (
    <>
      {actions.showNew && (
        <NewPromotionPopUp
          onClose={(refresh: boolean) => {
            if (refresh) {
              onRefresh && onRefresh(refresh);
            }
            setActions({ ...actions, showNew: false });
          }}
          isEdit={false}
        />
      )}
      {actions.showEdit && (
        <NewPromotionPopUp
          onClose={(refresh: boolean, promotionId: string) => {
            if (refresh) {
              onRefresh && onRefresh(refresh);
            }
            setActions({
              ...actions,
              showEdit: false,
              promotionId: "",
              isActive: false,
            });
          }}
          isEdit={true}
          isActive={actions.isActive}
          promotionId={actions.promotionId}
        />
      )}
      {actions.showDelete && (
        <DeletePromotionPopUp
          promotionId={actions.promotionId}
          onClose={(refresh: boolean) => {
            if (refresh) {
              onRefresh && onRefresh(refresh);
            }
            setActions({
              ...actions,
              showDelete: false,
              promotionId: "",
              isActive: false,
            });
          }}
        />
      )}
      <CollapsiblePanel
        title="Promotions"
        className="payment-detail-header"
        collapsibleClassName="full-width"
        isOpened={false}
      >
        <TableContainer className="default-table seller-table">
          <TableGrid
            data={data}
            headers={showTableHeader ? columns() : ""}
            isShowPlaceholder={data.length === 0 ? false : true}
            tableHeader={
              <TableWithHeaderButtons
                title="Purchase Link"
                totalItems={20}
                icon="uj"
                isShowHeaderButton={true}
                onNewButtonClick={() => {
                  if (!rolesAndPermissionStore.hasManagePermission("Create"))
                    return;
                  setActions({ ...actions, showNew: true });
                }}
                showRecentButton={false}
                description="Create a product or service guarantee banner that can be displayed on a Checkout page."
              />
            }
            cellSpacing={20}
            totalItemCount={20}
          />
        </TableContainer>
      </CollapsiblePanel>
    </>
  );
};

export default PromotionsGrid;
